export default "__VITE_ASSET__a3aEdmlh__"